import {BlockedDomainStatus} from './blocked-domain-status.enum';
import {BlockedDomain} from './blocked-domain.model';
export class DPBlockedDomain {
  id: string;
  dp: string;
  status: BlockedDomainStatus;
  comment: string;
  traces: string[];
  bd: BlockedDomain;
  blockedDomain: BlockedDomain;
  emailSent: boolean;
  reminderEmailSent: boolean;
  impressions: string;
  createDateTime: number;
  updateDateTime: number;
}
